import {
  // Box,
  ChevronUp,
  // Edit,
  // Eye,
  // Filter,
  // GitMerge,
  PlusCircle,
  RotateCcw,
  // Sliders,
  // StopCircle,
  // Trash2,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react"; // ,{ useEffect, useState }
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Brand from "../../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../../core/redux/action";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";

const Products = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [productlist, setProductlist] = useState([]);

  const columns = [
    { accessorKey: "Name", header: "Name" },
    { accessorKey: "Product_Code", header: "Product Code" },
    { accessorKey: "Category_Code", header: "Category Code" },
    { accessorKey: "Description", header: "Description" },
    { accessorKey: "Scan_Identifier", header: "Scan Identifier" },
    { accessorKey: "Requires_Customization", header: "Requires Customization" },
    {
      accessorKey: "Length__mm",
      header: "Length (mm)",
      Cell: ({ cell }) => cell.getValue() + " mm",
    },
    {
      accessorKey: "Width__mm",
      header: "Width (mm)",
      Cell: ({ cell }) => cell.getValue() + " mm",
    },
    {
      accessorKey: "Height__mm",
      header: "Height (mm)",
      Cell: ({ cell }) => cell.getValue() + " mm",
    },
    {
      accessorKey: "Weight__gms",
      header: "Weight (gms)",
      Cell: ({ cell }) => cell.getValue() + " gms",
    },
    { accessorKey: "EAN", header: "EAN" },
    { accessorKey: "UPC", header: "UPC" },
    { accessorKey: "ISBN", header: "ISBN" },
    { accessorKey: "Color", header: "Color" },
    { accessorKey: "Size", header: "Size" },
    { accessorKey: "Brand", header: "Brand" },
    { accessorKey: "Item_Detail_Fields", header: "Item Detail Fields" },
    { accessorKey: "Tags", header: "Tags" },
    {
      accessorKey: "Image_Url",
      header: "Image URL",
      Cell: ({ cell }) => (
        <img src={cell.getValue()} alt="Product" style={{ width: "50px" }} />
      ),
    },
    { accessorKey: "Product_Page_Url", header: "Product Page URL" },
    { accessorKey: "Tax_Type_Code", header: "Tax Type Code" },
    { accessorKey: "GST_Tax_Type_Code", header: "GST Tax Type Code" },
    { accessorKey: "Base_Price", header: "Base Price" },
    { accessorKey: "Cost_Price", header: "Cost Price" },
    { accessorKey: "TAT", header: "TAT" },
    { accessorKey: "MRP", header: "MRP" },
    { accessorKey: "Updated", header: "Updated" },
    { accessorKey: "Category_Name", header: "Category Name" },
    { accessorKey: "Enabled", header: "Enabled" },
    { accessorKey: "Type", header: "Type" },
    { accessorKey: "Component_Product_Code", header: "Component Product Code" },
    { accessorKey: "Component_Quantity", header: "Component Quantity" },
    { accessorKey: "Component_Price", header: "Component Price" },
    { accessorKey: "HSN_CODE", header: "HSN Code" },
    { accessorKey: "Tax_Calculation_Type", header: "Tax Calculation Type" },
    { accessorKey: "Batch_Group", header: "Batch Group" },
    {
      accessorKey: "GRN_expiry_tolerance__in_days",
      header: "GRN Expiry Tolerance (Days)",
    },
    {
      accessorKey: "Dispatch_expiry_tolerance__in_days",
      header: "Dispatch Expiry Tolerance (Days)",
    },
    {
      accessorKey: "Return_expiry_tolerance__in_days",
      header: "Return Expiry Tolerance (Days)",
    },
    { accessorKey: "Expirable", header: "Expirable" },
    { accessorKey: "Determine_Expiry_From", header: "Determine Expiry From" },
    { accessorKey: "Shelf_Life", header: "Shelf Life" },
    { accessorKey: "Expiry_Date", header: "Expiry Date" },
    { accessorKey: "Sku_Type", header: "SKU Type" },
    { accessorKey: "Fragile", header: "Fragile" },
    { accessorKey: "Dangerous_Good", header: "Dangerous Good" },
  ];

  console.log(productlist, "productlist p");
  console.log(columns, "productlist c");

  const route = all_routes;

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const prodcutDataListApi = async () => {
    // await axios.get(`${backendUrl}/inventory/items`).then((res) => {
    //   console.log(res, "data");
    //   setProductlist(res.data.ResponseData);
    //   //   dispatch({ type: "PRODUCT_LIST", payload: data });
    // });

    const response = await apiHandler({
      method: "GET",
      route: "/inventory/items",
    });

    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Product List</h4>
              <h6>Manage your products</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                    onClick={() => {
                      showConfirmationAlert();
                    }}
                  />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <i data-feather="printer" className="feather-printer" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={renderRefreshTooltip}
                onClick={prodcutDataListApi}
              >
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link to={route.productsync} className="btn btn-added">
              <PlusCircle className="me-2 iconsize" />
              Get Product Sync
            </Link>
          </div>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
        {/* /product list */}
        <Brand />
      </div>
    </div>
  );
};

export default Products;
